import React, { FC } from 'react';
import RcTooltip, { RCTooltip as RCTooltipType } from 'rc-tooltip';
import './rc-tooltip.css';
import './styles.scss';

export const Tooltip: FC<RCTooltipType.Props> = ({ children, trigger = ['hover'], ...props }) => {
  return (
    <RcTooltip trigger={trigger} {...props}>
      {children}
    </RcTooltip>
  );
};
